export const GOOGLE_MAP_KEY: string = process.env.REACT_APP_GOOGLE_MAP_API_KEY ?? '';
export const GOOGLE_MAP_Position =
  process.env.REACT_APP_MapPosition !== undefined ? JSON.parse(process.env.REACT_APP_MapPosition) : { lat: 0, lng: 0 };
